import React from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "./TestimonialSection.css";

import TestimonialCard from "./TestimonialCard/TestimonialCard";
import Common_Title from "../../common_components/common_title/Common_Title";

const testimonialsData = [
  {
    id: 1,
    name: "Yogesh",
    role: "Consultant @ANZ - Contract",
    product: "Career Booster",
    review: "Very detailed, crisp, and timely.",
    variantClass: "variant-green",
  },
  {
    id: 2,
    name: "Vipulkumar",
    role: "Product Development Specialist @3M India",
    product: "Featured profile",
    review: "Had effective interactions throughout the process. Satisfied with the outcome!",
    variantClass: "variant-pink",
  },
  {
    id: 3,
    name: "Molby Dsouza",
    role: "Front Desk Manager @celebrity Cruises",
    product: "Resume Writing",
    review: "Was formal, well-constructed and worded in a proper way. Overall communication was good between the writer and myself.",
    variantClass: "variant-blue",
  },

    {
    id: 1,
    name: "Yogesh",
    role: "Consultant @ANZ - Contract",
    product: "Career Booster",
    review: "Very detailed, crisp, and timely.",
    variantClass: "variant-green",
  },
  {
    id: 2,
    name: "Vipulkumar",
    role: "Product Development Specialist @3M India",
    product: "Featured profile",
    review: "Had effective interactions throughout the process. Satisfied with the outcome!",
    variantClass: "variant-pink",
  },
  {
    id: 3,
    name: "Molby Dsouza",
    role: "Front Desk Manager @celebrity Cruises",
    product: "Resume Writing",
    review: "Was formal, well-constructed and worded in a proper way. Overall communication was good between the writer and myself.",
    variantClass: "variant-blue",
  },

    {
    id: 1,
    name: "Yogesh",
    role: "Consultant @ANZ - Contract",
    product: "Career Booster",
    review: "Very detailed, crisp, and timely.",
    variantClass: "variant-green",
  },
  {
    id: 2,
    name: "Vipulkumar",
    role: "Product Development Specialist @3M India",
    product: "Featured profile",
    review: "Had effective interactions throughout the process. Satisfied with the outcome!",
    variantClass: "variant-pink",
  },
  {
    id: 3,
    name: "Molby Dsouza",
    role: "Front Desk Manager @celebrity Cruises",
    product: "Resume Writing",
    review: "Was formal, well-constructed and worded in a proper way. Overall communication was good between the writer and myself.",
    variantClass: "variant-blue",
  },
];

const TestimonialSection = () => {
  return (
    <div className="testimonials-section-parent">
      <Container>
        {/* Section Header Title */}
        <div className="title_div mb-4">
          <Common_Title title="What Our  " subTitle="Users Have To Say" />
        </div>

        {/* Swiper Slider Wrapper */}
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={24}
          slidesPerView={3.5}
          pagination={{ clickable: true }}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          breakpoints={{
            // when window width is >= 768px (tablets)
            0: {
              slidesPerView: 1,
            },

             575: {
              slidesPerView: 2,
            },
            // when window width is >= 1200px (desktops)
            1200: {
              slidesPerView: 3.5,
            },
          }}
          className="testimonial-swiper p-2 pb-5"
        >
          {testimonialsData.map((item) => (
            <SwiperSlide key={item.id} className="h-auto">
              <TestimonialCard
                name={item.name}
                role={item.role}
                product={item.product}
                review={item.review}
                variantClass={item.variantClass}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </div>
  );
};

export default TestimonialSection;